<template>
	<div class="chat-settings-option">
		<label><input :name="name" type="checkbox" @change="onUpdate" v-bind="{checked: value}"> {{ title }}</label>
	</div>
</template>

<script>
export default {
	props: {
		title: String,
		name: String,
		value: Boolean,
	},

	methods: {
		onUpdate(e){
			this.$emit('input', e.target.checked);
		},
	},
}
</script>

<style lang="less" scoped>
.chat-settings-option > * {
	width: 100%;
}

label > input {
	vertical-align: middle;
}
</style>
